import { get } from 'lodash-es';
import { buildStylesPath, buildStylesBySubmodelPath } from 'client/data/models/vehicle-v2';
import { getQuery } from 'client/utils/location';
import { APPRAISER_STYLE_PAGE_NAME } from 'site-modules/appraiser/constants/appraiser';
import { ExperimentUtil } from 'client/utils/experiment/experiment-util';

export const APPRAISER_PRELOAD_EXPERIMENT = 'EMO-4182';

export const APPRAISER_PRELOAD_RECIPES = {
  CTRL: 'ctrl',
  CHAL_1: 'chal1',
};

export const selectEmo4182Context = state => ({
  pageName: get(state, 'pageContext.page.name', ''),
  location: get(state, 'pageContext.location', {}),
  emo4182Recipe: ExperimentUtil.getForcedOrAssignedRecipeName({
    state,
    campaignName: APPRAISER_PRELOAD_EXPERIMENT,
    defaultVal: APPRAISER_PRELOAD_RECIPES.CTRL,
  }),
});

export const isGraphqlAllStylesPreloadRecipe = recipeName => recipeName === APPRAISER_PRELOAD_RECIPES.CHAL_1;

export const isAllStylesPreloadEligible = styleIds => {
  if (!styleIds) return true;

  const styleIdCount = Array.isArray(styleIds) ? styleIds.length : String(styleIds).split(',').length;

  return styleIdCount !== 1;
};

export const getIsEligibleForGraphQlStylesAbTest = ({ pageName, location, emo4182Recipe }) => {
  const { styleIds } = getQuery(location);
  return (
    pageName === APPRAISER_STYLE_PAGE_NAME &&
    isAllStylesPreloadEligible(styleIds) &&
    emo4182Recipe === APPRAISER_PRELOAD_RECIPES.CHAL_1
  );
};

export const getAppraiserStylesPath = ({ pageName, location, emo4182Recipe, make, model, year }) => {
  const isEligibleForGraphQlStylesAbTest = getIsEligibleForGraphQlStylesAbTest({
    pageName,
    location,
    emo4182Recipe,
  });

  return isEligibleForGraphQlStylesAbTest
    ? buildStylesBySubmodelPath({ make, model, year })
    : buildStylesPath({ make, model, year });
};
